export function Heading({ children }) {
  return (
    <p className="text-2xl text-white ">
      <b className="bg-black ">{children}</b>
    </p>
  );
}
